<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('triggers') }} -> {{ $t('create-trigger') }}
    </h1>
    <div class="main__body">
      <div class="form-row">
        <div class="form-group">
          <label>{{ $t('name-trigger') }}</label>
          <input class="large" type="text" :placeholder="$t('name-trigger')" v-model="trigger.name">
          <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
        </div>
      </div>
      <div class="form-row mt-1">
        <button class="btn btn-primary" type="submit" @click="createTrigger">{{ $t('create-trigger') }}</button>
      </div>
      <p class="gray-about mt-2">{{ $t('create-trigger-about-1') }}<br>
        {{ $t('create-trigger-about-2') }}</p>
    </div>
  </div>
</template>

<style scoped>
p.light-help{
  width: 826px;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'createTrigger',
  data: function(){
    return{
      trigger: {
        name: null,
      },
      errors: [],
    }
  },
  methods: {
    createTrigger: function(){
      axios.post('createTrigger', this.trigger).then(response => {
        var status = response.data.status;
        if(status){
          this.trigger.name = null;
          this.errors = [];
          this.$toast.success("Триггер успешно создан");
        }else{
          this.errors = response.data.errors;
        }
      });
    }
  }
}
</script>